/**
 * Ascending or descending. A const object rather than an enum so a data grid's `'asc' | 'desc'`
 * literals assign directly, which is what makes `SortModelSchema` usable from the front end.
 */
export const SortOrder = {
    Ascending: 'asc',
    Descending: 'desc',
};
//# sourceMappingURL=sortOrder.js.map